export default function Canvas_Shapes() {
  return (
    <div>
      <h1>Canvas_Shapes Component</h1>
    </div>
  );
}
